
import photoCropperDialog from "../dialogs/photo-cropper-dialog.vue";
import { mapState, mapMutations } from "vuex";
import InvalidFormatDialog from "../dialogs/menu-upload-info-dialog.vue";

export default {
  components: { photoCropperDialog, InvalidFormatDialog },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showPhotoCropDialog: false,
      cropImg: null,
      photo: null,
      MAX_IMAGE_SIZE_IN_BYTES: 2097152,
      showUnsupportedFormatWarning: false
    };
  },
  computed: {
    ...mapState("menu", ["menuUploadImageList"]),
    getPhoto() {
      return (
        this.menuUploadImageList?.find((img) => img.itemId === this.item.id)
          ?.image || null
      );
    }
  },
  methods: {
    ...mapMutations("menu", ["ADD_IMAGE_TO_LIST", "DELETE_IMAGE_BY_ITEM_ID"]),
    openFileUpload() {
      if (this.$refs.fileupload.$el instanceof HTMLElement) {
        this.$refs.fileupload.$el.querySelector("input").click();
      }
    },
    handleCropPhoto(img) {
      this.showPhotoCropDialog = false;
      this.ADD_IMAGE_TO_LIST({ itemId: this.item.id, image: img });
      this.$nuxt.$emit("reapply-filter");
    },
    photoChanged(val) {
      if (!val) return;
      const allowedFormats = ["image/png", "image/jpeg", "image/jpg"];
      const fileFormat = val.type;

      if (!allowedFormats.includes(fileFormat)) {
        this.showUnsupportedFormatWarning = true;
        this.$nextTick(() => {
          this.photo = null;
          this.$refs.fileupload.$el.querySelector("input").value = null; // Reset input value
        });

        return;
      }
      if (val && val.size > this.MAX_IMAGE_SIZE_IN_BYTES) {
        this.showUnsupportedFormatWarning = true;
        this.$nextTick(() => {
          this.photo = null;
          this.$refs.fileupload.$el.querySelector("input").value = null; // Reset input value
        });
        return;
      } else {
        this.ADD_IMAGE_TO_LIST({ itemId: this.item.id, image: val });
        this.showPhotoCropDialog = true;
      }
    },
    editPhoto() {
      this.showPhotoCropDialog = true;
    },
    deletePhoto() {
      this.DELETE_IMAGE_BY_ITEM_ID(this.item.id);
      this.photo = null;
      this.$refs.fileupload.reset();
    }
  }
};
